// constants
import { EnqActionTypes } from "./constants";

export interface EnqActionType {
  type:
    | EnqActionTypes.API_RESPONSE_SUCCESS
    | EnqActionTypes.API_RESPONSE_ERROR
    | EnqActionTypes.GET_ENQ
    | EnqActionTypes.DELETE_ENQ;
  payload: {} | string;
}

interface EnqDetails {
  name: string;
  id: string;
  email: string;
  message: string;
}

// common success
export const enqApiResponseSuccess = (
  actionType: string,
  data: EnqDetails | {}
): EnqActionType => ({
  type: EnqActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const enqApiResponseError = (
  actionType: string,
  error: string
): EnqActionType => ({
  type: EnqActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const getEnq = (): EnqActionType => ({
  type: EnqActionTypes.GET_ENQ,
  payload: {},
});

export const deleteEnq = (id: string): EnqActionType => ({
  type: EnqActionTypes.DELETE_ENQ,
  payload: { id },
});
